import React from 'react';

export const communicationConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/communication',
        component: React.lazy(() => import('./AppCommunication')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/messages',
        component: React.lazy(() => import('./Messages')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/tasks',
        component: React.lazy(() => import('./Tasks')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/notifications',
        component: React.lazy(() => import('./Notifications')),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/task-management",
        component: React.lazy(() => import("./Task/TasksPage")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/task-create-practitioner",
        component: React.lazy(() => import("./Task/CreatePractitionerTask")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/task-bin",
        component: React.lazy(() => import("./Task/TaskBin")),
      },
    ],
  },
];